var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _path9, _g3, _g4, _path0, _path1, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 431.81,
    height: 220.446,
    viewBox: "0 0 431.81 220.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#0a5b80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#a32a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#a32a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#b02d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#b02d1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#b72f1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.183,
    y1: 0.5,
    x2: 0.81,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#0f1010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3.377,
    y1: -9.927,
    x2: -3.212,
    y2: -9.927,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#bf965c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#e2b16d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#e2b16d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#efbb73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#efbb73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#e0b06c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -29.464,
    y1: -54.463,
    x2: -28.358,
    y2: -54.463,
    xlinkHref: "#linear-gradient-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_969",
    "data-name": "Groupe 969",
    transform: "translate(0.556 -364.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_882",
    "data-name": "Groupe 882",
    transform: "translate(5.393 370.054)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_896",
    "data-name": "Trac\\xE9 896",
    d: "M181.951,370.054,26.244,459.95l164.993,95.343,155.708-89.9Z",
    transform: "translate(32.515 -370.054)",
    fill: "#dfdfdf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_897",
    "data-name": "Trac\\xE9 897",
    d: "M41.051,459.873l5.191,3.26,116.874-2.083-61.961-35.88Zm41.107-10.8,18.988-10.962,19.574,11.337Z",
    transform: "translate(59.436 -269.849)",
    fill: "#dfdfdf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_898",
    "data-name": "Trac\\xE9 898",
    d: "M207.015,420.1a.932.932,0,0,0,.471-1.212,6.185,6.185,0,0,0-1.665-1.9,9.911,9.911,0,0,0-2.75-1.722,2.108,2.108,0,0,0-1.759.13L95.831,479.832,91.855,490.1c2.3,1.933,104.486-63.584,104.486-63.584Z",
    transform: "translate(151.801 -288.086)",
    fill: "#dfdfdf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_899",
    "data-name": "Trac\\xE9 899",
    d: "M218.866,431.919l-17.523-10.162a12.252,12.252,0,0,0-12.284-.011l-32.943,19.036,7.552,4.382L109.384,476.5l17.72,11.01,47.251-36.221a32.689,32.689,0,0,0,31.974-.383l12.529-7.24A6.79,6.79,0,0,0,218.866,431.919Z",
    transform: "translate(183.67 -279.068)",
    fill: "#dfdfdf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_900",
    "data-name": "Trac\\xE9 900",
    d: "M99.931,447.293l-4.272,2.46L17.567,404.67l-.008.006a2.088,2.088,0,0,0-2.28-.121l-7.164,4.137a5.342,5.342,0,0,0-2.663,4.345L5.4,414.153a2.081,2.081,0,0,0,1.158,1.981l0,.011L80.2,458.658,52.041,474.868l16.505,9.8,12.222-6.893L116.9,457.092Z",
    transform: "translate(-5.393 -307.845)",
    fill: "#dfdfdf"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_890",
    "data-name": "Groupe 890",
    transform: "translate(308.789 505.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_901",
    "data-name": "Trac\\xE9 901",
    d: "M199.176,424.041l-19.45,8.113a27.122,27.122,0,0,0-21.2,2.514l-25.484,10.6,17.407,10.1a32.73,32.73,0,0,0,32.805.028l12.529-7.24a6.7,6.7,0,0,0,3.311-6.521l.079-.022Z",
    transform: "translate(-76.71 -407.015)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_902",
    "data-name": "Trac\\xE9 902",
    d: "M133.044,425.338v17.571l20.677,11.759V427.453Z",
    transform: "translate(-76.71 -404.657)",
    fill: "#8e2515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_903",
    "data-name": "Trac\\xE9 903",
    d: "M195.785,441.569l-12.529,7.24a32.73,32.73,0,0,1-32.805-.028l-17.407-10.1,32.94-19.036a12.264,12.264,0,0,1,12.287.008l17.523,10.165A6.791,6.791,0,0,1,195.785,441.569Z",
    transform: "translate(-76.71 -417.999)",
    fill: "#e35a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_883",
    "data-name": "Groupe 883",
    transform: "translate(58.966 22.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_904",
    "data-name": "Trac\\xE9 904",
    d: "M133.978,426.346l5.182,2.8v17.513l-5.182-2.8Z",
    transform: "translate(-133.978 -425.738)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_905",
    "data-name": "Trac\\xE9 905",
    d: "M134.092,426.923l3.365,1.77v14.836l-3.365-1.77Z",
    transform: "translate(-133.771 -424.69)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_906",
    "data-name": "Trac\\xE9 906",
    d: "M134.974,426.13l5.021,2.958-.834.448-5.182-2.8Z",
    transform: "translate(-133.978 -426.13)",
    fill: "#cedde3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_907",
    "data-name": "Trac\\xE9 907",
    d: "M135.817,427.629l.834-.448v17.407l-.834.555Z",
    transform: "translate(-130.635 -424.222)",
    fill: "#aab9c0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_887",
    "data-name": "Groupe 887",
    transform: "translate(6.788 25.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_884",
    "data-name": "Groupe 884",
    transform: "translate(5.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_908",
    "data-name": "Trac\\xE9 908",
    d: "M166.177,427.459l-48.255,28.2V470.3l48.255-28.2Z",
    transform: "translate(-116.55 -426.621)",
    fill: "#f09200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_909",
    "data-name": "Trac\\xE9 909",
    d: "M165.343,427.162,117.435,455.23l1.372.965L167.063,428Z",
    transform: "translate(-117.435 -427.162)",
    fill: "#fecc4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_910",
    "data-name": "Trac\\xE9 910",
    d: "M118.807,438.087l-1.372-.965V452.1l1.372.627Z",
    transform: "translate(-117.435 -409.053)",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_885",
    "data-name": "Groupe 885",
    transform: "translate(0 28.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_911",
    "data-name": "Trac\\xE9 911",
    d: "M121.914,437.408l-5.964,3.542v14.641l5.964-3.541Z",
    transform: "translate(-114.577 -436.57)",
    fill: "#aab9c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_912",
    "data-name": "Trac\\xE9 912",
    d: "M121.08,437.11l-5.617,3.415,1.372.964,5.964-3.542Z",
    transform: "translate(-115.462 -437.11)",
    fill: "#cedde3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_913",
    "data-name": "Trac\\xE9 913",
    d: "M116.835,439.287l-1.372-.964V453.3l1.372.627Z",
    transform: "translate(-115.462 -434.908)",
    fill: "#696969"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_886",
    "data-name": "Groupe 886",
    transform: "translate(15.385 1.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_914",
    "data-name": "Trac\\xE9 914",
    d: "M121.494,444.924V435.6l-.506.3-.066,9.34Z",
    transform: "translate(-120.922 -413.364)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_915",
    "data-name": "Trac\\xE9 915",
    d: "M123.745,443.609v-9.324l-.506.3-.066,9.34Z",
    transform: "translate(-116.829 -415.755)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_916",
    "data-name": "Trac\\xE9 916",
    d: "M126,442.294V432.97l-.506.3-.066,9.34Z",
    transform: "translate(-112.737 -418.146)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_917",
    "data-name": "Trac\\xE9 917",
    d: "M128.247,440.979v-9.324l-.506.3-.065,9.34Z",
    transform: "translate(-108.644 -420.537)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_918",
    "data-name": "Trac\\xE9 918",
    d: "M130.5,439.664V430.34l-.506.3-.065,9.34Z",
    transform: "translate(-104.552 -422.928)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_919",
    "data-name": "Trac\\xE9 919",
    d: "M132.749,438.349v-9.324l-.506.3-.065,9.34Z",
    transform: "translate(-100.459 -425.319)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_920",
    "data-name": "Trac\\xE9 920",
    d: "M135,437.034V427.71l-.506.3-.065,9.34Z",
    transform: "translate(-96.367 -427.71)",
    fill: "#3d3d3d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_921",
    "data-name": "Trac\\xE9 921",
    d: "M181.761,436.7l-9,5.2a23.524,23.524,0,0,1-23.582-.02l-12.515-7.259,23.68-13.685a8.809,8.809,0,0,1,8.832.006l12.6,7.307A4.879,4.879,0,0,1,181.761,436.7Z",
    transform: "translate(-70.134 -414.807)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_922",
    "data-name": "Trac\\xE9 922",
    d: "M160.341,423.007a8.816,8.816,0,0,1,8.832.008l12.6,7.3a4.792,4.792,0,0,1,2.3,3.184,4.847,4.847,0,0,0-2.3-5.253l-12.6-7.307a8.809,8.809,0,0,0-8.832-.006l-23.68,13.685,1.79,1.037Z",
    transform: "translate(-70.134 -414.807)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_888",
    "data-name": "Groupe 888",
    transform: "translate(73.287 11.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_923",
    "data-name": "Trac\\xE9 923",
    d: "M146.725,426.167c-.313-.163-.468-.366-.465-.6a1.091,1.091,0,0,1,.465-.752l-.025-.014a4.037,4.037,0,0,1-1.378.383,2.115,2.115,0,0,1-1.153-.22c-.459-.245-.626-.55-.507-.919a2.511,2.511,0,0,1,1.22-1.147,7.623,7.623,0,0,1,1.784-.755l.829.44a7.555,7.555,0,0,0-.9.273,5.579,5.579,0,0,0-.778.358,1.358,1.358,0,0,0-.645.572c-.062.169.034.321.3.462a2.128,2.128,0,0,0,2.021-.33l.395-.225.688.366-.375.214a1.469,1.469,0,0,0-.671.592c-.068.183.017.344.271.476a1.121,1.121,0,0,0,.64.127,1.677,1.677,0,0,0,.69-.228,1.537,1.537,0,0,0,.719-.767l1.195-.008a2.448,2.448,0,0,1-1.265,1.274,4.8,4.8,0,0,1-1.685.611A2.191,2.191,0,0,1,146.725,426.167Z",
    transform: "translate(-130.761 -422.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_924",
    "data-name": "Trac\\xE9 924",
    d: "M145.925,425.74a3.779,3.779,0,0,1-1.637.5,2.824,2.824,0,0,1-1.53-.307c-.547-.29-.778-.623-.7-1s.465-.761,1.147-1.15a6.331,6.331,0,0,1,1.727-.7l.859.454a6.71,6.71,0,0,0-.84.24,5.047,5.047,0,0,0-.806.352q-1.023.579-.172,1.031a1.769,1.769,0,0,0,1.784-.144,3.765,3.765,0,0,0,.727-.533l.637-.121,2.285,1.448-2.962,1.68-.82-.437L147.475,426l-.978-.625A5.106,5.106,0,0,1,145.925,425.74Z",
    transform: "translate(-133.636 -420.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_925",
    "data-name": "Trac\\xE9 925",
    d: "M140.331,426.959l2.263,1.2a1.411,1.411,0,0,0,1.409.113c.279-.158.38-.321.3-.5a1.787,1.787,0,0,0-.772-.609l-1.849-.978,1.271-.721,2.263,1.2a1.426,1.426,0,0,0,1.417.113c.273-.158.372-.321.3-.5a1.848,1.848,0,0,0-.8-.625l-1.823-.961,1.262-.719,3.8,2.009-1,.572-.643-.175-.079.045a.521.521,0,0,1-.093.521,1.892,1.892,0,0,1-.572.473,2.88,2.88,0,0,1-1.944.386l-.051.025c.178.383-.042.747-.634,1.082a2.977,2.977,0,0,1-1.417.42,2.748,2.748,0,0,1-1.392-.341l-2.486-1.313Z",
    transform: "translate(-139.06 -418.812)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_889",
    "data-name": "Groupe 889",
    transform: "translate(0 53.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_926",
    "data-name": "Trac\\xE9 926",
    d: "M113.054,437.14l7.379,4.71v14.685l-7.379-4.71Z",
    transform: "translate(-113.054 -436.532)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_927",
    "data-name": "Trac\\xE9 927",
    d: "M114.05,436.924l7.217,4.87-.834.448-7.379-4.71Z",
    transform: "translate(-113.054 -436.924)",
    fill: "#cedde3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_928",
    "data-name": "Trac\\xE9 928",
    d: "M115.672,439.1l.834-.448v14.578l-.834.555Z",
    transform: "translate(-108.294 -433.782)",
    fill: "#aab9c0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_966",
    "data-name": "Groupe 966",
    transform: "translate(72.851 370.39)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_929",
    "data-name": "Trac\\xE9 929",
    d: "M87.9,493.9l155.707-89.9-.019,4.7L87.879,498.6Z",
    transform: "translate(77.114 -308.663)",
    fill: "#4993d2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_930",
    "data-name": "Trac\\xE9 930",
    d: "M29.337,460.069l155.708-89.9,164.992,95.343-155.707,89.9Z",
    transform: "translate(-29.319 -370.174)",
    fill: "#75b8ed"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_931",
    "data-name": "Trac\\xE9 931",
    d: "M35.585,453.79,174.2,373.765l146.876,84.874-138.61,80.025Z",
    transform: "translate(-17.959 -363.644)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.468
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_891",
    "data-name": "Groupe 891",
    transform: "translate(159.667 152.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_932",
    "data-name": "Trac\\xE9 932",
    d: "M92.462,428.412c.792.437,1.192.891,1.206,1.364s-.378.93-1.153,1.381l-.358.206,2.7,1.494-1.429.826-7.437-4.114,1.95-1.127A4.319,4.319,0,0,1,92.462,428.412Zm-1.5,2.288.273-.161c.349-.2.519-.406.5-.606s-.234-.42-.659-.654a2.507,2.507,0,0,0-1.1-.347,1.866,1.866,0,0,0-1.015.268l-.347.2Z",
    transform: "translate(-85.989 -417.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_933",
    "data-name": "Trac\\xE9 933",
    d: "M95.252,432.008l-7.434-4.115,1.429-.826,6.225,3.444,1.981-1.144,1.209.668Z",
    transform: "translate(-82.664 -418.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_934",
    "data-name": "Trac\\xE9 934",
    d: "M99.655,429.676l-2.319-.784-2,1.158,1.434,1.3-1.429.826-5.566-5.233,1.939-1.122,9.373,3.029Zm-3.813-1.3L93.7,427.65c-.13-.042-.448-.158-.955-.341s-.84-.31-1-.38c.245.189.51.4.789.634s.9.783,1.857,1.649Z",
    transform: "translate(-79.106 -421.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_935",
    "data-name": "Trac\\xE9 935",
    d: "M104.208,428.3l-1.744,1.009L94.7,427.706l-.07.039a9.594,9.594,0,0,1,1.454.656l4.064,2.249-1.322.766L91.391,427.3l1.756-1.017,7.685,1.589.056-.034a9.957,9.957,0,0,1-1.372-.648l-4.061-2.243,1.316-.761Z",
    transform: "translate(-76.168 -424.189)",
    fill: "#fff"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_936",
    "data-name": "Trac\\xE9 936",
    d: "M29.331,406.77l.019-4.7,164.993,95.343-.019,4.7Z",
    transform: "translate(-29.331 -312.177)",
    fill: "#0b81d4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_963",
    "data-name": "Groupe 963",
    transform: "translate(41.572 30.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_892",
    "data-name": "Groupe 892",
    transform: "translate(161.281 84.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_937",
    "data-name": "Trac\\xE9 937",
    d: "M116.213,410.817l-14.9,8.6L107.522,423l14.9-8.6Z",
    transform: "translate(-101.313 -410.817)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_900",
    "data-name": "Groupe 900",
    transform: "translate(89.792 67.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_898",
    "data-name": "Groupe 898",
    transform: "translate(0.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_893",
    "data-name": "Groupe 893",
    transform: "translate(23.676 1.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_938",
    "data-name": "Trac\\xE9 938",
    d: "M85.451,406.21l.316-.32-1.089-.4-.28.333Z",
    transform: "translate(-84.398 -405.491)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_939",
    "data-name": "Trac\\xE9 939",
    d: "M86.057,406.5l.378-.294-1.029-.455-.344.309Z",
    transform: "translate(-83.191 -405.02)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_940",
    "data-name": "Trac\\xE9 940",
    d: "M86.612,406.817l.435-.265-.958-.506-.4.282Z",
    transform: "translate(-82.059 -404.483)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_894",
    "data-name": "Groupe 894",
    transform: "translate(17.588 0.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_941",
    "data-name": "Trac\\xE9 941",
    d: "M83.4,405.539l.113-.375s-1.2-.22-1.2-.2l-.073.383C82.241,405.327,83.4,405.539,83.4,405.539Z",
    transform: "translate(-82.238 -404.963)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_942",
    "data-name": "Trac\\xE9 942",
    d: "M84.113,405.728l.183-.361-.589-.138-.4-.1a1.816,1.816,0,0,0-.186-.039l-.141.372a1.341,1.341,0,0,1,.178.037l.392.09Z",
    transform: "translate(-80.894 -404.724)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_943",
    "data-name": "Trac\\xE9 943",
    d: "M84.8,405.952l.25-.343-1.137-.34-.212.353Z",
    transform: "translate(-79.586 -404.404)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_895",
    "data-name": "Groupe 895",
    transform: "translate(11.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_944",
    "data-name": "Trac\\xE9 944",
    d: "M81.247,405.23l-.1-.394-.189,0c-.113-.005-.262,0-.411.009l-.592.023.141.394.575-.025c.141-.006.285-.011.4-.006Z",
    transform: "translate(-79.954 -404.83)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_945",
    "data-name": "Trac\\xE9 945",
    d: "M81.957,405.276l-.028-.392s-.3-.022-.609-.037l-.6-.011.07.395.583.008C81.664,405.253,81.957,405.276,81.957,405.276Z",
    transform: "translate(-78.567 -404.82)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_946",
    "data-name": "Trac\\xE9 946",
    d: "M82.658,405.384,82.7,405l-.606-.073c-.3-.034-.609-.048-.609-.048v.389s.293.014.586.048Z",
    transform: "translate(-77.169 -404.745)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_896",
    "data-name": "Groupe 896",
    transform: "translate(5.063 0.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_947",
    "data-name": "Trac\\xE9 947",
    d: "M79.163,405.422l-.306-.374-1.063.249.342.366Z",
    transform: "translate(-77.794 -404.51)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_948",
    "data-name": "Trac\\xE9 948",
    d: "M79.839,405.313l-.24-.385-1.116.183.277.38Z",
    transform: "translate(-76.541 -404.728)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_949",
    "data-name": "Trac\\xE9 949",
    d: "M80.535,405.249l-.172-.392-.186.008-.4.039-.578.059.211.389.558-.056.386-.039Z",
    transform: "translate(-75.233 -404.857)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_897",
    "data-name": "Groupe 897",
    transform: "translate(0 1.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_950",
    "data-name": "Trac\\xE9 950",
    d: "M77.318,405.984l-.481-.317L76,406.1l.508.3Z",
    transform: "translate(-75.997 -404.389)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_951",
    "data-name": "Trac\\xE9 951",
    d: "M77.9,405.76l-.428-.34-.925.374.458.327Z",
    transform: "translate(-75.004 -404.838)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_952",
    "data-name": "Trac\\xE9 952",
    d: "M78.51,405.572l-.369-.359-1,.313.4.349Z",
    transform: "translate(-73.917 -405.214)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_899",
    "data-name": "Groupe 899",
    transform: "translate(0 3.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_953",
    "data-name": "Trac\\xE9 953",
    d: "M105,407.069l.249.143-13.68,7.9-15.628-9.018.3-.172,15.284,8.82,13.233-7.64.1.055Z",
    transform: "translate(-75.945 -405.92)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_908",
    "data-name": "Groupe 908",
    transform: "translate(159.547 25.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_906",
    "data-name": "Groupe 906",
    transform: "translate(0.499 8.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_901",
    "data-name": "Groupe 901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_954",
    "data-name": "Trac\\xE9 954",
    d: "M102.476,393.232l-.316.32,1.088.4.28-.333Z",
    transform: "translate(-98.541 -391.617)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_955",
    "data-name": "Trac\\xE9 955",
    d: "M101.873,392.962l-.378.294,1.029.455.344-.309Z",
    transform: "translate(-99.751 -392.108)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_956",
    "data-name": "Trac\\xE9 956",
    d: "M101.311,392.659l-.435.265.958.506.4-.282Z",
    transform: "translate(-100.876 -392.659)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_902",
    "data-name": "Groupe 902",
    transform: "translate(5.616 2.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_957",
    "data-name": "Trac\\xE9 957",
    d: "M104.467,393.811l-.113.375s1.2.22,1.2.2l.073-.383C105.625,394.022,104.467,393.811,104.467,393.811Z",
    transform: "translate(-100.168 -392.839)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_958",
    "data-name": "Trac\\xE9 958",
    d: "M103.782,393.659l-.183.361.586.138.406.1a1.871,1.871,0,0,0,.183.039l.144-.372a1.424,1.424,0,0,1-.18-.037l-.389-.09Z",
    transform: "translate(-101.54 -393.115)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_959",
    "data-name": "Trac\\xE9 959",
    d: "M103.118,393.466l-.25.343,1.137.34.212-.353Z",
    transform: "translate(-102.868 -393.466)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_903",
    "data-name": "Groupe 903",
    transform: "translate(11.98 3.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_960",
    "data-name": "Trac\\xE9 960",
    d: "M106.631,394.024l.1.395.189,0c.113.006.262,0,.409-.008l.595-.023-.141-.395-.575.025c-.141.006-.287.011-.4.006Z",
    transform: "translate(-102.393 -393.785)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_961",
    "data-name": "Trac\\xE9 961",
    d: "M105.886,393.985l.031.395s.3.023.609.037l.6.008-.07-.392-.583-.009C106.182,394.01,105.886,393.985,105.886,393.985Z",
    transform: "translate(-103.747 -393.805)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_962",
    "data-name": "Trac\\xE9 962",
    d: "M105.166,393.921l-.039.386.606.073c.3.034.609.048.609.048v-.389s-.293-.014-.589-.048Z",
    transform: "translate(-105.127 -393.921)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_904",
    "data-name": "Groupe 904",
    transform: "translate(18.299 2.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_963",
    "data-name": "Trac\\xE9 963",
    d: "M108.764,393.953l.306.374,1.063-.249-.342-.366Z",
    transform: "translate(-104.832 -393.712)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_964",
    "data-name": "Trac\\xE9 964",
    d: "M108.08,394.028l.24.385,1.116-.183-.277-.38Z",
    transform: "translate(-106.076 -393.46)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_965",
    "data-name": "Trac\\xE9 965",
    d: "M107.369,394.049l.172.392.186-.008.4-.04.578-.059-.211-.389-.558.056-.386.04Z",
    transform: "translate(-107.369 -393.288)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_905",
    "data-name": "Groupe 905",
    transform: "translate(24.071 1.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_966",
    "data-name": "Trac\\xE9 966",
    d: "M110.578,393.468l.481.317.841-.432-.508-.3Z",
    transform: "translate(-107.307 -393.05)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_967",
    "data-name": "Trac\\xE9 967",
    d: "M110.021,393.671l.428.34.925-.374-.458-.327Z",
    transform: "translate(-108.32 -392.58)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_968",
    "data-name": "Trac\\xE9 968",
    d: "M109.418,393.832l.369.359,1-.313-.4-.349Z",
    transform: "translate(-109.418 -392.179)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_907",
    "data-name": "Groupe 907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_969",
    "data-name": "Trac\\xE9 969",
    d: "M100.947,397.839l-.249-.143,13.68-7.9,15.628,9.018-.3.172-15.284-8.82-13.233,7.64-.1-.055Z",
    transform: "translate(-100.699 -389.797)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_916",
    "data-name": "Groupe 916",
    transform: "translate(54.314 47.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_914",
    "data-name": "Groupe 914",
    transform: "translate(0.145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_909",
    "data-name": "Groupe 909",
    transform: "translate(23.676 1.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_970",
    "data-name": "Trac\\xE9 970",
    d: "M72.861,399.028l.316-.32-1.088-.4-.28.333Z",
    transform: "translate(-71.809 -398.309)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_971",
    "data-name": "Trac\\xE9 971",
    d: "M73.468,399.317l.378-.294-1.029-.455-.344.309Z",
    transform: "translate(-70.602 -397.837)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_972",
    "data-name": "Trac\\xE9 972",
    d: "M74.022,399.635l.435-.265-.958-.506-.4.282Z",
    transform: "translate(-69.47 -397.301)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_910",
    "data-name": "Groupe 910",
    transform: "translate(17.589 0.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_973",
    "data-name": "Trac\\xE9 973",
    d: "M70.81,398.357l.113-.378s-1.2-.217-1.2-.2l-.07.38C69.652,398.145,70.81,398.357,70.81,398.357Z",
    transform: "translate(-69.649 -397.781)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_974",
    "data-name": "Trac\\xE9 974",
    d: "M71.526,398.546l.18-.361-.586-.141-.4-.1a1.518,1.518,0,0,0-.186-.037l-.144.369a1.315,1.315,0,0,1,.18.037l.389.093Z",
    transform: "translate(-68.307 -397.542)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_975",
    "data-name": "Trac\\xE9 975",
    d: "M72.206,398.77l.25-.343-1.137-.34-.212.353Z",
    transform: "translate(-66.997 -397.223)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_911",
    "data-name": "Groupe 911",
    transform: "translate(11.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_976",
    "data-name": "Trac\\xE9 976",
    d: "M68.66,398.046l-.1-.395H68.37c-.116-.005-.265,0-.411.006l-.595.025.141.394.575-.025c.144-.009.287-.011.4-.009Z",
    transform: "translate(-67.364 -397.648)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_977",
    "data-name": "Trac\\xE9 977",
    d: "M69.368,398.094l-.031-.392s-.3-.025-.606-.039l-.6-.009.07.395.583.008C69.075,398.071,69.368,398.094,69.368,398.094Z",
    transform: "translate(-65.975 -397.637)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_978",
    "data-name": "Trac\\xE9 978",
    d: "M70.069,398.2l.039-.386-.606-.076c-.3-.034-.606-.048-.606-.048v.392s.293.011.586.045Z",
    transform: "translate(-64.577 -397.564)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_912",
    "data-name": "Groupe 912",
    transform: "translate(5.064 0.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_979",
    "data-name": "Trac\\xE9 979",
    d: "M66.573,398.24l-.306-.374-1.063.249.342.366Z",
    transform: "translate(-65.204 -397.326)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_980",
    "data-name": "Trac\\xE9 980",
    d: "M67.249,398.131l-.24-.385-1.116.183.278.379Z",
    transform: "translate(-63.952 -397.544)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_981",
    "data-name": "Trac\\xE9 981",
    d: "M67.948,398.069l-.172-.395-.186.011-.4.039-.581.059.211.389.561-.059.383-.037Z",
    transform: "translate(-62.645 -397.674)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_913",
    "data-name": "Groupe 913",
    transform: "translate(0 1.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_982",
    "data-name": "Trac\\xE9 982",
    d: "M64.729,398.8l-.481-.317-.841.432.508.3Z",
    transform: "translate(-63.407 -397.207)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_983",
    "data-name": "Trac\\xE9 983",
    d: "M65.306,398.577l-.428-.34-.925.374.458.327Z",
    transform: "translate(-62.415 -397.656)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_984",
    "data-name": "Trac\\xE9 984",
    d: "M65.92,398.39l-.369-.359-1,.313.4.348Z",
    transform: "translate(-61.328 -398.031)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_915",
    "data-name": "Groupe 915",
    transform: "translate(0 3.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_985",
    "data-name": "Trac\\xE9 985",
    d: "M92.416,399.886l.249.143-13.68,7.9-15.628-9.018.3-.172,15.284,8.82,13.233-7.64.1.055Z",
    transform: "translate(-63.356 -398.737)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_923",
    "data-name": "Groupe 923",
    transform: "translate(80.682 92.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_917",
    "data-name": "Groupe 917",
    transform: "translate(21.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_986",
    "data-name": "Trac\\xE9 986",
    d: "M89.26,416.231l-4.337,2.5-4.686-2.7,4.337-2.5Z",
    transform: "translate(-80.236 -413.526)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_918",
    "data-name": "Groupe 918",
    transform: "translate(0 12.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_987",
    "data-name": "Trac\\xE9 987",
    d: "M81.737,420.574l-4.337,2.5-4.687-2.7,4.337-2.5Z",
    transform: "translate(-72.713 -417.869)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_988",
    "data-name": "Trac\\xE9 988",
    d: "M91.151,416.476l-13.336,7.7,16.628,9.6,13.336-7.7Z",
    transform: "translate(-63.437 -408.164)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.275
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_989",
    "data-name": "Trac\\xE9 989",
    d: "M88.736,415.014l-13.453,7.767,7.078,4.084L95.813,419.1Z",
    transform: "translate(-68.04 -410.82)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.275
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_990",
    "data-name": "Trac\\xE9 990",
    d: "M91.562,415.448l-15.526,8.964-1.737-1,15.526-8.964Z",
    transform: "translate(-69.83 -411.853)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_991",
    "data-name": "Trac\\xE9 991",
    d: "M99.5,420.352l-14.969,8.642-1.108-.639,14.969-8.642Z",
    transform: "translate(-53.236 -402.277)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_920",
    "data-name": "Groupe 920",
    transform: "translate(14.832 4.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_919",
    "data-name": "Groupe 919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_992",
    "data-name": "Trac\\xE9 992",
    d: "M88.981,418.3a54.287,54.287,0,0,1-6.738,2.911,16.6,16.6,0,0,1-4.267-3.058,54.716,54.716,0,0,1,6.738-2.911A16.684,16.684,0,0,1,88.981,418.3Z",
    transform: "translate(-77.976 -415.242)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_993",
    "data-name": "Trac\\xE9 993",
    d: "M88.981,418.3a54.287,54.287,0,0,1-6.738,2.911,16.6,16.6,0,0,1-4.267-3.058,54.716,54.716,0,0,1,6.738-2.911A16.684,16.684,0,0,1,88.981,418.3Z",
    transform: "translate(-77.976 -415.242)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_994",
    "data-name": "Trac\\xE9 994",
    d: "M82.319,420.305a16.722,16.722,0,0,1-4.267-3.06q1.547-.8,3.215-1.522-1.708.736-3.292,1.556a16.6,16.6,0,0,0,4.267,3.058c1.215-.431,2.39-.9,3.525-1.386Q84.1,419.668,82.319,420.305Z",
    transform: "translate(-77.976 -414.368)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_995",
    "data-name": "Trac\\xE9 995",
    d: "M88.981,418.3a54.287,54.287,0,0,1-6.738,2.911c-2.057-1.378-2.381-1.649-4.267-3.058a54.716,54.716,0,0,1,6.738-2.911A18.254,18.254,0,0,1,88.981,418.3Z",
    transform: "translate(-77.976 -415.242)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_922",
    "data-name": "Groupe 922",
    transform: "translate(8.643 8.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_921",
    "data-name": "Groupe 921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_996",
    "data-name": "Trac\\xE9 996",
    d: "M80.957,422.968a37.841,37.841,0,0,0,5.29-3.773,22.066,22.066,0,0,0-5.18-2.55,37.963,37.963,0,0,0-5.287,3.771A22.214,22.214,0,0,0,80.957,422.968Z",
    transform: "translate(-75.78 -416.644)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_997",
    "data-name": "Trac\\xE9 997",
    d: "M80.957,422.968a37.841,37.841,0,0,0,5.29-3.773,22.066,22.066,0,0,0-5.18-2.55,37.963,37.963,0,0,0-5.287,3.771A22.214,22.214,0,0,0,80.957,422.968Z",
    transform: "translate(-75.78 -416.644)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_998",
    "data-name": "Trac\\xE9 998",
    d: "M84.593,419.237a22.13,22.13,0,0,0-5.18-2.55q-1.446.862-2.756,1.8c.891-.637,1.832-1.251,2.815-1.837a22.121,22.121,0,0,1,5.18,2.55q-1.192,1.023-2.533,1.978Q83.425,420.238,84.593,419.237Z",
    transform: "translate(-74.186 -416.644)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_999",
    "data-name": "Trac\\xE9 999",
    d: "M81.769,415.835c-.786-.454-.874-1.141-.192-1.536a2.966,2.966,0,0,1,2.66.11c.789.457.874,1.144.192,1.536A2.957,2.957,0,0,1,81.769,415.835Z",
    transform: "translate(-57.432 -412.602)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1000",
    "data-name": "Trac\\xE9 1000",
    d: "M81.778,415.226c-.451-.256-.5-.648-.11-.874a1.681,1.681,0,0,1,1.516.062c.448.259.5.651.11.876A1.691,1.691,0,0,1,81.778,415.226Z",
    transform: "translate(-56.909 -412.301)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_930",
    "data-name": "Groupe 930",
    transform: "translate(23.85 59.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_924",
    "data-name": "Groupe 924",
    transform: "translate(37.265 9.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1001",
    "data-name": "Trac\\xE9 1001",
    d: "M70.107,405.178l-4.337,2.5,4.686,2.7,4.337-2.5Z",
    transform: "translate(-65.77 -405.178)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_925",
    "data-name": "Groupe 925",
    transform: "translate(16.065 21.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1002",
    "data-name": "Trac\\xE9 1002",
    d: "M62.583,409.521l-4.337,2.5,4.686,2.7,4.337-2.5Z",
    transform: "translate(-58.246 -409.521)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1003",
    "data-name": "Trac\\xE9 1003",
    d: "M83.193,411.883l-13.336,7.7-16.628-9.6,13.336-7.7Z",
    transform: "translate(-51.305 -401.177)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.275
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1004",
    "data-name": "Trac\\xE9 1004",
    d: "M79.639,409.765l-13.453,7.767-7.078-4.084,13.453-7.767Z",
    transform: "translate(-40.615 -395.008)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.275
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1005",
    "data-name": "Trac\\xE9 1005",
    d: "M76.778,406.917l-15.526,8.964,1.736,1,15.526-8.964Z",
    transform: "translate(-36.717 -392.759)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1006",
    "data-name": "Trac\\xE9 1006",
    d: "M67.515,401.893l-14.969,8.642,1.108.639,14.969-8.642Z",
    transform: "translate(-52.546 -401.893)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_927",
    "data-name": "Groupe 927",
    transform: "translate(27.569 11.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_926",
    "data-name": "Groupe 926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1007",
    "data-name": "Trac\\xE9 1007",
    d: "M67.373,406.077a35.617,35.617,0,0,0-5.044,3.889,23.073,23.073,0,0,0,5.3,2.463,35.617,35.617,0,0,0,5.044-3.889A22.962,22.962,0,0,0,67.373,406.077Z",
    transform: "translate(-62.329 -406.077)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1008",
    "data-name": "Trac\\xE9 1008",
    d: "M67.373,406.077a35.617,35.617,0,0,0-5.044,3.889,23.073,23.073,0,0,0,5.3,2.463,35.617,35.617,0,0,0,5.044-3.889A22.962,22.962,0,0,0,67.373,406.077Z",
    transform: "translate(-62.329 -406.077)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1009",
    "data-name": "Trac\\xE9 1009",
    d: "M62.385,408.725a22.929,22.929,0,0,0,5.3,2.463q1.386-.892,2.638-1.854-1.277.985-2.7,1.9a23.073,23.073,0,0,1-5.3-2.463q1.124-1.048,2.407-2.035Q63.489,407.7,62.385,408.725Z",
    transform: "translate(-62.329 -404.881)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1010",
    "data-name": "Trac\\xE9 1010",
    d: "M67.373,406.077a35.617,35.617,0,0,0-5.044,3.889c2.393,1.186,2.86,1.375,5.3,2.463a35.617,35.617,0,0,0,5.044-3.889A24.863,24.863,0,0,0,67.373,406.077Z",
    transform: "translate(-62.329 -406.077)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_929",
    "data-name": "Groupe 929",
    transform: "translate(20.116 15.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_928",
    "data-name": "Groupe 928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1011",
    "data-name": "Trac\\xE9 1011",
    d: "M59.684,410.51a51.582,51.582,0,0,1,6.532-3.055,17.6,17.6,0,0,1,4.422,2.987,51.764,51.764,0,0,1-6.532,3.055A17.473,17.473,0,0,1,59.684,410.51Z",
    transform: "translate(-59.684 -407.455)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1012",
    "data-name": "Trac\\xE9 1012",
    d: "M59.684,410.51a51.582,51.582,0,0,1,6.532-3.055,17.6,17.6,0,0,1,4.422,2.987,51.764,51.764,0,0,1-6.532,3.055A17.473,17.473,0,0,1,59.684,410.51Z",
    transform: "translate(-59.684 -407.455)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1013",
    "data-name": "Trac\\xE9 1013",
    d: "M64.138,407.489a17.58,17.58,0,0,1,4.422,2.99c-.995.555-2.032,1.088-3.108,1.589q1.653-.769,3.182-1.626a17.6,17.6,0,0,0-4.422-2.987q-1.771.689-3.424,1.463Q62.4,408.161,64.138,407.489Z",
    transform: "translate(-57.679 -407.455)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1014",
    "data-name": "Trac\\xE9 1014",
    d: "M67.4,407.544a2.957,2.957,0,0,0,2.66.113c.682-.395.6-1.082-.192-1.536a2.957,2.957,0,0,0-2.66-.11C66.531,406.4,66.618,407.09,67.4,407.544Z",
    transform: "translate(-26.717 -394.891)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1015",
    "data-name": "Trac\\xE9 1015",
    d: "M67.411,406.937a1.681,1.681,0,0,0,1.516.062c.389-.225.341-.617-.107-.876a1.7,1.7,0,0,0-1.516-.062C66.915,406.286,66.963,406.678,67.411,406.937Z",
    transform: "translate(-26.193 -394.589)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_933",
    "data-name": "Groupe 933",
    transform: "translate(112.562 17.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_932",
    "data-name": "Groupe 932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_931",
    "data-name": "Groupe 931",
    transform: "translate(2.487 2.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1016",
    "data-name": "Trac\\xE9 1016",
    d: "M91.657,395.026c-2.376-1.265-4.593-2.562-6.749-3.951a38.063,38.063,0,0,1,5.58-3.162c2.376,1.265,4.591,2.564,6.749,3.954A38.35,38.35,0,0,1,91.657,395.026Z",
    transform: "translate(-84.908 -387.913)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.336
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1017",
    "data-name": "Trac\\xE9 1017",
    d: "M89.68,387.694l-5.5,3.12c-.22.124-.2.344.054.488l1.482.868a.766.766,0,0,0,.118.056h0a.918.918,0,0,0,.73-.017l5.5-3.117,7,4.095-5.5,3.117c-.214.121-.2.333.031.479l1.516.885a.945.945,0,0,0,.837.034l5.5-3.12a1.517,1.517,0,0,0,.9-1.274,2.067,2.067,0,0,0-1.22-1.651l-6.366-3.726a5.79,5.79,0,0,0-2.6-.724c-.085-.006-.166-.006-.245-.006A4.549,4.549,0,0,0,89.68,387.694Z",
    transform: "translate(-84.025 -387.201)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.336
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_936",
    "data-name": "Groupe 936",
    transform: "translate(103.873 33.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_935",
    "data-name": "Groupe 935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_934",
    "data-name": "Groupe 934",
    transform: "translate(2.234 1.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1018",
    "data-name": "Trac\\xE9 1018",
    d: "M81.735,404.65c1.871-1.2,17.96-10.469,20.079-11.529a56.834,56.834,0,0,1,6.338,3.711c-1.871,1.2-17.96,10.469-20.082,11.529A56.789,56.789,0,0,1,81.735,404.65Z",
    transform: "translate(-81.735 -393.121)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.336
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1019",
    "data-name": "Trac\\xE9 1019",
    d: "M111.9,396.456l-6.253-3.658a.944.944,0,0,0-.848-.042l-1.3.741a.378.378,0,0,0-.082.059l0,0c-.13.124-.079.3.132.426l6.253,3.661L89.5,409.3l-6.253-3.661a.968.968,0,0,0-.829-.051l-1.336.758c-.206.124-.178.338.068.482l6.25,3.661a5.689,5.689,0,0,0,2.359.7,4.847,4.847,0,0,0,2.717-.471l19.743-11.337a1.468,1.468,0,0,0,.891-1.415.641.641,0,0,0-.025-.144A2.3,2.3,0,0,0,111.9,396.456Z",
    transform: "translate(-80.942 -392.674)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.336
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_939",
    "data-name": "Groupe 939",
    transform: "translate(87.795 90.126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_938",
    "data-name": "Groupe 938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1020",
    "data-name": "Trac\\xE9 1020",
    d: "M87.822,415.767,83.37,413.2a2.921,2.921,0,0,0-2.615-.127L75.674,416c-.659.38-.561,1.057.22,1.508l4.453,2.573Zm-1.634-.307-6.374,3.68L76.8,417.4c-.62-.361-.688-.9-.149-1.214l4.422-2.553a2.344,2.344,0,0,1,2.1.087Z",
    transform: "translate(-75.237 -412.818)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_937",
    "data-name": "Groupe 937",
    transform: "translate(5.795 3.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1021",
    "data-name": "Trac\\xE9 1021",
    d: "M77.326,414.414c-.107-.189.062-.369.378-.4a.82.82,0,0,1,.764.279c.107.189-.062.369-.378.406A.825.825,0,0,1,77.326,414.414Z",
    transform: "translate(-77.294 -414.005)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_942",
    "data-name": "Groupe 942",
    transform: "translate(65.765 73.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_941",
    "data-name": "Groupe 941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_940",
    "data-name": "Groupe 940",
    transform: "translate(2.291 1.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1022",
    "data-name": "Trac\\xE9 1022",
    d: "M76.764,412.354h0c1.364-.786,1.195-2.161-.38-3.072l-2.894-1.668a1.438,1.438,0,0,0-1.3-.054l-3.737,2.156c-.333.192-.29.527.093.747l2.894,1.671A5.923,5.923,0,0,0,76.764,412.354Z",
    transform: "translate(-68.232 -407.431)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1023",
    "data-name": "Trac\\xE9 1023",
    d: "M71.536,409.337a1.47,1.47,0,0,1-1.316-.054l-.964-.558,1.22-.7.964.558C71.829,408.8,71.871,409.143,71.536,409.337Z",
    transform: "translate(-66.371 -406.358)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1024",
    "data-name": "Trac\\xE9 1024",
    d: "M67.858,410.213a2,2,0,0,0,1.8.073l3.525-2.035c.459-.265.4-.73-.13-1.037a2,2,0,0,0-1.8-.073l-3.523,2.035C67.269,409.44,67.328,409.906,67.858,410.213Z",
    transform: "translate(-67.419 -406.961)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_945",
    "data-name": "Groupe 945",
    transform: "translate(67.366 93.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_944",
    "data-name": "Groupe 944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_943",
    "data-name": "Groupe 943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1025",
    "data-name": "Trac\\xE9 1025",
    d: "M89.583,419.984l-9.536-5.507a3.1,3.1,0,0,0-2.77-.132l-8.826,5.1c-.7.406-.595,1.122.231,1.6l9.539,5.5Z",
    transform: "translate(-67.988 -414.078)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1026",
    "data-name": "Trac\\xE9 1026",
    d: "M74.617,422.017,70.2,419.47c-.8-.462-.888-1.161-.194-1.561l4.61-2.663a3.008,3.008,0,0,1,2.705.113l4.413,2.548c.344.2.38.5.085.668l-6.045,3.491A1.293,1.293,0,0,1,74.617,422.017Z",
    transform: "translate(-65.162 -412.447)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1027",
    "data-name": "Trac\\xE9 1027",
    d: "M73.252,417.253l-.521.3c-.561.324-.49.891.158,1.262h0l2.548-1.471h0A2.419,2.419,0,0,0,73.252,417.253Z",
    transform: "translate(-60.054 -408.706)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_947",
    "data-name": "Groupe 947",
    transform: "translate(48.115 79.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1028",
    "data-name": "Trac\\xE9 1028",
    d: "M70.731,419.9l9.243-5.34c1.973-1.136,1.725-3.122-.552-4.436h0c-2.277-1.316-5.718-1.457-7.688-.318l-9.246,5.337c-1.973,1.136-1.725,3.125.552,4.438h0C65.317,420.9,68.758,421.036,70.731,419.9Z",
    transform: "translate(-61.156 -409.037)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1029",
    "data-name": "Trac\\xE9 1029",
    d: "M72.224,409.794s-7.386,4.033-9.505,5.557c-.781.561-1.939,1.733.321,3.091h0l.073.045a5.329,5.329,0,0,0,5.281.138c2.508-1.234,9.379-5.346,9.379-5.346,1.3-.741,1.141-2.04-.349-2.9l-.7-.409A4.976,4.976,0,0,0,72.224,409.794Z",
    transform: "translate(-60.135 -408.487)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_946",
    "data-name": "Groupe 946",
    transform: "translate(3.731 8.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1030",
    "data-name": "Trac\\xE9 1030",
    d: "M62.7,412.752a1.006,1.006,0,0,0,.907.037c.231-.135.2-.369-.065-.524a1,1,0,0,0-.907-.037C62.406,412.363,62.434,412.6,62.7,412.752Z",
    transform: "translate(-62.481 -412.137)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1031",
    "data-name": "Trac\\xE9 1031",
    d: "M139.207,425.382l22.753-13.135-8.122-4.687-12.067,6.966-5.7-.417-22.325-12.884c-2.5-1.44-6.273-1.595-8.437-.347l-4.283,2.472Z",
    transform: "translate(59.448 -345.93)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.293
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_950",
    "data-name": "Groupe 950",
    transform: "translate(175.051 61.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_949",
    "data-name": "Groupe 949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_948",
    "data-name": "Groupe 948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1032",
    "data-name": "Trac\\xE9 1032",
    d: "M112.215,402.678l9.682,5.587-6.015,3.473-9.682-5.587Z",
    transform: "translate(-106.2 -402.678)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.293
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_953",
    "data-name": "Groupe 953",
    transform: "translate(192.643 68.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_952",
    "data-name": "Groupe 952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1033",
    "data-name": "Trac\\xE9 1033",
    d: "M113.114,406.534c1.443-1.381,4.74-1.657,7.366-.617s3.582,3,2.139,4.385-4.74,1.657-7.366.617S111.672,407.914,113.114,406.534Z",
    transform: "translate(-112.443 -405.286)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.293
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_951",
    "data-name": "Groupe 951",
    transform: "translate(4.743 3.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1034",
    "data-name": "Trac\\xE9 1034",
    d: "M114.245,406.725a1.373,1.373,0,0,1,1.324-.11c.471.186.643.538.383.786a1.376,1.376,0,0,1-1.322.11C114.16,407.325,113.988,406.973,114.245,406.725Z",
    transform: "translate(-114.126 -406.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.293
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_954",
    "data-name": "Groupe 954",
    transform: "translate(25.942 42.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1035",
    "data-name": "Trac\\xE9 1035",
    d: "M68.188,396.067l-14.9,8.6,6.209,3.583,14.9-8.6Z",
    transform: "translate(-53.288 -396.067)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.275
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_955",
    "data-name": "Groupe 955",
    transform: "translate(134.468 99.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1036",
    "data-name": "Trac\\xE9 1036",
    d: "M106.7,416.107l-14.9,8.6,6.208,3.583,14.9-8.6Z",
    transform: "translate(-91.799 -416.107)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_958",
    "data-name": "Groupe 958",
    transform: "translate(80.327 8.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_957",
    "data-name": "Groupe 957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_956",
    "data-name": "Groupe 956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1037",
    "data-name": "Trac\\xE9 1037",
    d: "M93.432,390.725l-8.95,5.168c-3.049,1.761-8.375,1.539-11.9-.493h0l19.989-11.54h0C96.1,385.892,96.481,388.966,93.432,390.725Z",
    transform: "translate(-72.587 -383.86)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_959",
    "data-name": "Groupe 959",
    transform: "translate(114.296 51.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1038",
    "data-name": "Trac\\xE9 1038",
    d: "M119.383,416.192l-2.066-16.582-11.737-.485c-2.934-.124-5.371.891-5.98,2.486h0c-.51,1.344-2.2,2.353-4.5,2.691h0q-2,.3-4.05.482h0c-4.038.372-6.687,2.359-6.386,4.788h0c.361,2.877,4.692,5.377,9.674,5.583Z",
    transform: "translate(-84.641 -399.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.332
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1039",
    "data-name": "Trac\\xE9 1039",
    d: "M101.237,399.705l1.924,15.439-4.975-.206L96.262,399.5Z",
    transform: "translate(-63.512 -398.418)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.332
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_960",
    "data-name": "Groupe 960",
    transform: "translate(105.33 2.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1040",
    "data-name": "Trac\\xE9 1040",
    d: "M104.044,391.675l-17.209-9.931-5.375,3.1,17.209,9.931Z",
    transform: "translate(-81.459 -381.744)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.278
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1041",
    "data-name": "Trac\\xE9 1041",
    d: "M102.826,401.773l.62,4.978-3.933-.163-.62-4.978Z",
    transform: "translate(55.567 -343.066)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.332
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_961",
    "data-name": "Groupe 961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1042",
    "data-name": "Trac\\xE9 1042",
    d: "M111.138,396.161l39.637,23.1-2.058,1.188-39.637-23.1Z",
    transform: "translate(74.088 -352.974)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1043",
    "data-name": "Trac\\xE9 1043",
    d: "M44.146,404.254l2.058-1.188,114.235,65.922-2.058,1.188Z",
    transform: "translate(-43.968 -340.421)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1044",
    "data-name": "Trac\\xE9 1044",
    d: "M109.08,401.489l13.172-7.6,2.377,1.371-13.172,7.6Z",
    transform: "translate(74.088 -357.114)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1045",
    "data-name": "Trac\\xE9 1045",
    d: "M95.749,393.8l13.172-7.6,2.377,1.372-13.172,7.6Z",
    transform: "translate(49.85 -371.101)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1046",
    "data-name": "Trac\\xE9 1046",
    d: "M84.582,380.836l39.646,22.879L122.17,404.9,82.524,382.024Z",
    transform: "translate(25.806 -380.836)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1047",
    "data-name": "Trac\\xE9 1047",
    d: "M102.172,386.434l38.435,22.18L138.55,409.8l-38.435-22.18Z",
    transform: "translate(57.787 -370.658)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1048",
    "data-name": "Trac\\xE9 1048",
    d: "M100.6,412.809l14.047,8.106-2.058,1.188L98.544,414Z",
    transform: "translate(54.932 -322.707)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1049",
    "data-name": "Trac\\xE9 1049",
    d: "M84.569,445.731,137.618,415.1,140,416.475,86.946,447.1Z",
    transform: "translate(29.525 -318.535)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1050",
    "data-name": "Trac\\xE9 1050",
    d: "M52.414,405.689l18.923-10.925,2.376,1.371L54.79,407.06Z",
    transform: "translate(-28.936 -355.513)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1051",
    "data-name": "Trac\\xE9 1051",
    d: "M59.409,407.115,92.1,388.24l.742.428L60.151,407.543Z",
    transform: "translate(-16.219 -367.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1052",
    "data-name": "Trac\\xE9 1052",
    d: "M47.052,408l15.924-9.194.743.429L47.8,408.431Z",
    transform: "translate(-38.684 -348.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1053",
    "data-name": "Trac\\xE9 1053",
    d: "M44.083,406.265l7.553-4.361,2.376,1.371-7.553,4.361Z",
    transform: "translate(-44.083 -342.533)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1054",
    "data-name": "Trac\\xE9 1054",
    d: "M70.72,401.229l35.322-20.393,2.376,1.371L73.1,402.6Z",
    transform: "translate(4.346 -380.836)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1055",
    "data-name": "Trac\\xE9 1055",
    d: "M103.2,436.134l55.873-32.258,2.376,1.371-55.873,32.257Z",
    transform: "translate(63.398 -338.946)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1056",
    "data-name": "Trac\\xE9 1056",
    d: "M59.957,425.448l36.717-21.2.743.429L60.7,425.877Z",
    transform: "translate(-15.222 -338.268)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1057",
    "data-name": "Trac\\xE9 1057",
    d: "M90.256,408.025l23.859,14,.643-.371-23.859-14Z",
    transform: "translate(39.864 -332.079)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1058",
    "data-name": "Trac\\xE9 1058",
    d: "M101.583,401.672l38.565,22.255.643-.371L102.225,401.3Z",
    transform: "translate(60.456 -343.629)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1059",
    "data-name": "Trac\\xE9 1059",
    d: "M71.656,438.286l53.058-30.632.743.429L72.4,438.715Z",
    transform: "translate(6.048 -332.079)",
    fill: "#fafdff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1060",
    "data-name": "Trac\\xE9 1060",
    d: "M58.514,396.271l.644-.371,74.173,42.8-.644.372Z",
    transform: "translate(-17.845 -353.45)",
    fill: "#fafdff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1061",
    "data-name": "Trac\\xE9 1061",
    d: "M70.138,418.97l-6.779-3.912,1.566-.9,6.779,3.912Z",
    transform: "translate(-9.036 -320.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1062",
    "data-name": "Trac\\xE9 1062",
    d: "M70.359,419.1l-23.45-13.532,1.566-.9,23.449,13.532Z",
    transform: "translate(-38.944 -337.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1063",
    "data-name": "Trac\\xE9 1063",
    d: "M91.7,431.411,74.689,421.6l1.566-.9,17.009,9.815Z",
    transform: "translate(11.562 -308.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1064",
    "data-name": "Trac\\xE9 1064",
    d: "M122.567,411.832l-14.727,8.5-1.808-1.043,14.727-8.5Z",
    transform: "translate(68.545 -326.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1065",
    "data-name": "Trac\\xE9 1065",
    d: "M110.765,418.553l-14.727,8.5-1.808-1.044,14.726-8.5Z",
    transform: "translate(47.088 -314.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_962",
    "data-name": "Groupe 962",
    transform: "translate(88.575 24.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1066",
    "data-name": "Trac\\xE9 1066",
    d: "M94.148,389.441a5.2,5.2,0,0,0-1.773.586l-15.7,9.063c-1.722.995-1.5,2.731.482,3.878l5.628,3.249a6.889,6.889,0,0,0,1.677.673,7.089,7.089,0,0,0,5.042-.4l15.7-9.063c1.722-.995,1.5-2.731-.482-3.878l-5.628-3.246A7.977,7.977,0,0,0,94.148,389.441Zm9.255,4.872c1.144.662,1.271,1.666.276,2.238l-15.7,9.063a4.075,4.075,0,0,1-2.908.231,4.006,4.006,0,0,1-.969-.389l-5.628-3.249c-1.144-.659-1.271-1.665-.279-2.238l15.7-9.063a2.963,2.963,0,0,1,1.017-.338,4.568,4.568,0,0,1,2.86.5Z",
    transform: "translate(-75.514 -389.356)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.336
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_964",
    "data-name": "Groupe 964",
    transform: "translate(38.22 155.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1067",
    "data-name": "Trac\\xE9 1067",
    d: "M103,426.328,42.893,458.7v2.333l122.067,1.178v-2.333Zm-.008,12.935L122.565,450.6,84,450.225Z",
    transform: "translate(-42.893 -423.995)",
    fill: "#b16a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1068",
    "data-name": "Trac\\xE9 1068",
    d: "M103,425.5,42.893,460.2,164.96,461.38Zm-.008,12.935,19.574,11.337L84,449.4Z",
    transform: "translate(-42.893 -425.5)",
    fill: "#ffc011"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_965",
    "data-name": "Groupe 965",
    transform: "translate(175.628 126.153)"
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1069",
    "data-name": "Trac\\xE9 1069",
    d: "M100.721,478.1l88.363-53s.657-.978-1.023-3.776c-1.77-2.945-3.1-3.083-3.1-3.083L97.125,470.926l-1.891,3.348Z",
    transform: "translate(-85.142 -408.935)",
    fill: "#ed9e00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1070",
    "data-name": "Trac\\xE9 1070",
    d: "M186.61,419.555l-1.734-1.313-87.84,52.683-1.755,2.951,2.941-1.267Z",
    transform: "translate(-85.055 -408.934)",
    fill: "#ffe353"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1071",
    "data-name": "Trac\\xE9 1071",
    d: "M184.745,418.708l.244.3L96.308,472.192l.049-.429Z",
    transform: "translate(-83.19 -408.087)",
    fill: "#f8c417"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 4.005,
    height: 107.908,
    transform: "translate(103.643 9.758) rotate(58.999)",
    fill: "#f8c417"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1072",
    "data-name": "Trac\\xE9 1072",
    d: "M104.771,444.16l-10.43,2.824-1.333-2.218,8.291-7.857s-.555,1.364.251,1.561l.809.2a2.914,2.914,0,0,0,.411,2.145c.685.961,2.57,1.11,2.57,1.11A3.367,3.367,0,0,0,104.771,444.16Z",
    transform: "translate(-89.189 -374.997)",
    fill: "#deba89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1073",
    "data-name": "Trac\\xE9 1073",
    d: "M104.822,437.535l-13.169,9.708,16.15-6.453S104.447,440.81,104.822,437.535Z",
    transform: "translate(-91.652 -373.858)",
    fill: "#d3a47c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1074",
    "data-name": "Trac\\xE9 1074",
    d: "M107.8,438.69l-16.15,6.453,15.581-4.221S106.944,440.288,107.8,438.69Z",
    transform: "translate(-91.652 -371.759)",
    fill: "#c98666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1075",
    "data-name": "Trac\\xE9 1075",
    d: "M91.653,443.313l5.153-1.4L95.471,439.7Z",
    transform: "translate(-91.653 -369.929)",
    fill: "#393333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1076",
    "data-name": "Trac\\xE9 1076",
    d: "M143.184,417.689a8.6,8.6,0,0,0-2.04-2.472,1.4,1.4,0,0,0-1.564-.076l-10.607,6.375s1.271.13,2.956,2.934c1.6,2.669.975,3.6.975,3.6l10.672-6.411a1.4,1.4,0,0,0,.665-1.415A7.423,7.423,0,0,0,143.184,417.689Z",
    transform: "translate(-23.804 -414.939)",
    fill: "#bf1f47"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1077",
    "data-name": "Trac\\xE9 1077",
    d: "M141.843,417.42a7.284,7.284,0,0,0-1.744-2.111,1.2,1.2,0,0,0-1.336-.065l-9.063,5.445s1.088.113,2.528,2.508c1.37,2.28.831,3.08.831,3.08l9.119-5.478a1.2,1.2,0,0,0,.569-1.209A6.309,6.309,0,0,0,141.843,417.42Z",
    transform: "translate(-22.48 -414.698)",
    fill: "#ed3160"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1078",
    "data-name": "Trac\\xE9 1078",
    d: "M139.742,416.86a4.319,4.319,0,0,0-1.181-1.375.9.9,0,0,0-.964.006l-6.76,4.061s.781.037,1.733,1.618c.9,1.508.485,2.071.485,2.071l6.8-4.086a.9.9,0,0,0,.457-.845A3.75,3.75,0,0,0,139.742,416.86Z",
    transform: "translate(-20.413 -414.195)",
    fill: "#ff4f7a"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 17.585,
    height: 14.879,
    transform: "translate(98.822 2.088)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAGqADAAQAAAABAAAAFgAAAACq8XkxAAAB8ElEQVRIDc2UOU4EMRBFGfZ9FSkhEiESByAhIycjQEiIDJEgMsQJOAEBZ+AAJMTk3AEQ+zbM8J7VBT1Dz0aAKOmPPW13PX+X3aVqtdr1F9H9FxAZ/xd0enwwgno63YlSuzUi+QLJX9FLpufVjYPndoEtQQA8LcvoDQXoib56BPZI2zKagoCskaGC3pEg3egiQWgf0H07sEIQgG0SlJBuPpAg3QhRukgQ2nsFTHjDqAEB2GVmH+pFgnQjqN5NHnLH+C26A+aCCsOEKYDs0xlC/ShAOiqjqI2LiBMXbh2PrW0I6lma69q5vDhbYfJYplFaNYwGkWAB3rm4d0J0G46FlclTnl9cdgd+RDd2j3hq4nE0gSbRFJrOZN/njjtvJJPuXchATi6oMNIKge0xGrAACSiChNM8JFw3B7kEYOsZzNWHI6H+j63URTgweQCsaRK1jhry6Dtiz9MTYNbKpAJmkED/xzbVJzZpXpaisEY1x5uXUrCqKzrWwjtyjW7q2vyz1AdwzpyG8XW862Z4mjxJtp4wZUT71QdwmkZa/NRsXczl5Vn6rtSL6WfHC+sdSceY1u2pMO+Etq1o5MiX3T4TxrdNoBf3DcAhbUfRDGRdBJk8vtRbHWXPTW4GcuusUfrO4WIz917H3VagKoBfu8iv5hPta7tkRTNO9gAAAABJRU5ErkJggg==",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1079",
    "data-name": "Trac\\xE9 1079",
    d: "M143.371,422.757l-12.194,7.158a1.63,1.63,0,0,0,.113-1.06,6.089,6.089,0,0,0-.533-1.711,12.043,12.043,0,0,0-.592-1.122,12.477,12.477,0,0,0-.969-1.443,6.749,6.749,0,0,0-1.251-1.279,2.19,2.19,0,0,0-.927-.473l12.2-7.155a2,2,0,0,1,.8.38,6.113,6.113,0,0,1,1.288,1.254,12.455,12.455,0,0,1,1.062,1.558c.211.358.383.69.527.989a6.689,6.689,0,0,1,.575,1.685A1.776,1.776,0,0,1,143.371,422.757Z",
    transform: "translate(-27.356 -413.607)",
    fill: "#7d7d7c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1080",
    "data-name": "Trac\\xE9 1080",
    d: "M142.866,421.294l-12.174,7.316a6.089,6.089,0,0,0-.533-1.711,12.043,12.043,0,0,0-.592-1.122,12.477,12.477,0,0,0-.969-1.443,6.749,6.749,0,0,0-1.251-1.279l12.067-7.248a6.113,6.113,0,0,1,1.288,1.254,12.455,12.455,0,0,1,1.062,1.558c.211.358.383.69.527.989A6.689,6.689,0,0,1,142.866,421.294Z",
    transform: "translate(-26.758 -413.361)",
    fill: "#adadac"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1081",
    "data-name": "Trac\\xE9 1081",
    d: "M141.484,418.8l-12.132,7.29a12.043,12.043,0,0,0-.592-1.122,12.477,12.477,0,0,0-.969-1.443l12.1-7.273a12.455,12.455,0,0,1,1.062,1.558C141.168,418.168,141.34,418.5,141.484,418.8Z",
    transform: "translate(-25.951 -412.552)",
    fill: "#c7c6c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1082",
    "data-name": "Trac\\xE9 1082",
    d: "M138.146,416.277s1.367.155,3.151,3.2c1.558,2.652,1.107,3.711,1.02,3.869l.995-.583s.69-1-1.006-3.892c-1.787-3.041-3.153-3.2-3.153-3.2l-12.1,7.178Z",
    transform: "translate(-27.296 -413.609)",
    fill: "#9c9b9a",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1083",
    "data-name": "Trac\\xE9 1083",
    d: "M137.575,416.655s1.367.155,3.151,3.2c1.558,2.655,1.1,3.714,1.02,3.869l.995-.581s.688-1-1.009-3.892c-1.784-3.041-3.151-3.2-3.151-3.2l-12.2,7.155.02,0Z",
    transform: "translate(-28.509 -412.916)",
    fill: "#9c9b9a",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1084",
    "data-name": "Trac\\xE9 1084",
    d: "M129.722,417.038s1.367.155,3.151,3.2c1.558,2.652,1.1,3.711,1.02,3.869l.995-.583s.688-1-1.009-3.892c-1.784-3.041-3.151-3.2-3.151-3.2Z",
    transform: "translate(-22.44 -412.225)",
    fill: "#9c9b9a",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1085",
    "data-name": "Trac\\xE9 1085",
    d: "M136.309,417.416s1.367.155,3.151,3.2c1.556,2.655,1.1,3.714,1.02,3.869l.992-.58s.69-1-1.006-3.892c-1.784-3.041-3.151-3.2-3.151-3.2l-12.2,7.155.02,0Z",
    transform: "translate(-30.811 -411.533)",
    fill: "#9c9b9a",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1086",
    "data-name": "Trac\\xE9 1086",
    d: "M128.456,417.8s1.367.155,3.151,3.2c1.556,2.652,1.1,3.711,1.02,3.869l.992-.583s.69-1-1.006-3.892c-1.784-3.041-3.151-3.2-3.151-3.2Z",
    transform: "translate(-24.742 -410.842)",
    fill: "#9c9b9a",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_968",
    "data-name": "Groupe 968",
    transform: "translate(11.446 469.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1087",
    "data-name": "Trac\\xE9 1087",
    d: "M19.707,405.643l.008-.006,81.118,46.834-.907.952-.051.961a5.338,5.338,0,0,1-2.66,4.345l-5.236,3.024-2.114,2.215L8.7,417.116l0-.011a2.085,2.085,0,0,1-1.158-1.984l.056-1.113a5.335,5.335,0,0,1,2.663-4.345l7.164-4.137A2.088,2.088,0,0,1,19.707,405.643Z",
    transform: "translate(-7.541 -405.241)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1088",
    "data-name": "Trac\\xE9 1088",
    d: "M56.659,446.54l-23.871-.085-4.858-2.817,47.893-27.575,16.97,9.8Z",
    transform: "translate(29.529 -385.567)",
    fill: "#cedde3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1089",
    "data-name": "Trac\\xE9 1089",
    d: "M53.746,426.928l-23.863-.08-.355,19.579,23.86.079Z",
    transform: "translate(32.434 -365.959)",
    fill: "#91a4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1090",
    "data-name": "Trac\\xE9 1090",
    d: "M33.037,428.656l-4.878-2.8-.355,19.58,4.877,2.8Z",
    transform: "translate(29.297 -367.771)",
    fill: "#78909b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1091",
    "data-name": "Trac\\xE9 1091",
    d: "M74.485,419.538,38.351,440.217,38,459.8l36.132-20.68Z",
    transform: "translate(47.829 -379.249)",
    fill: "#aab9c0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_967",
    "data-name": "Groupe 967",
    transform: "translate(96.262 55.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1092",
    "data-name": "Trac\\xE9 1092",
    d: "M53.866,425.366l.008-.006,1.787,1.031-.91.953-.048.961a5.337,5.337,0,0,1-2.663,4.343l-5.233,3.024-2.116,2.215-1.832-1.051,0-.009a2.085,2.085,0,0,1-1.158-1.984l.056-1.116a5.346,5.346,0,0,1,2.663-4.345l7.164-4.137A2.088,2.088,0,0,1,53.866,425.366Z",
    transform: "translate(-41.7 -424.963)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1093",
    "data-name": "Trac\\xE9 1093",
    d: "M52.21,425.61l-7.164,4.137a5.342,5.342,0,0,0-2.663,4.345l-.056,1.113A2.118,2.118,0,0,0,45.5,437.15l7.164-4.137a5.341,5.341,0,0,0,2.663-4.345l.056-1.113A2.116,2.116,0,0,0,52.21,425.61Z",
    transform: "translate(-40.565 -424.31)",
    fill: "#ffd895"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesure);
export default __webpack_public_path__ + "static/media/mesure.280d124b5e9aed2993733b7c72fa213c.svg";
export { ForwardRef as ReactComponent };